import React from 'react';
import HeroImage from './../components/HeroImage/HeroImage';

function Home() {
  return (
    <div>
     <HeroImage/>
    </div>
  )
}

export default Home